/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, version } from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import moment from 'moment';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  rebateProgramLabel,
  quarterLabel,
  AtrAccountsRecLabel,
  balanceDueLabel,
  overriddenLabel,
  paidInFullLabel,
} from './ConstantData';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { QtrAccRecColumns } from '../tablehead';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ActionDropDownComp, { NameTooltipComp } from '../ActionDropdownComp';
import RedTextRenderComp from '../RedTextRenderComp';
import {
  getAccRecNDCSingleDetail,
  singleAccRecNDCData,
  dispatchQARBalanceDue,
  dispatchQAROveridden,
  dispatchQARPaidInFull,
} from './store/actions';
import {
  ndcDetailSingle,
  dispatchNDCBalanceDue,
  dispatchNDCOveridden,
  dispatchNDCPaidInFull,
  ndcDetailFirstLoadAction,
} from '../AccRecNDCDetail/store/actions';
import {
  goToArSummaryAccRecNDCSingle,
  getInvoiceDetails,
  updateInvoiceBalanced,
  undoInvoiceBalanced,
} from '../ARCommonFunctions';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import * as AR_CONST from '../AccountsRevConstants';
import ModalDialog from '../../../../SharedModules/Dialog/ModalDialog';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';

const QtrAccountsRec = (props) => {
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [dialogText, setDialogText] = React.useState(false);
  const [qtrAccRecTableData, setQtrAccRecTableData] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const [confimPopup, setConfimPopup] = React.useState(false);
  const [pinned, setPinned] = React.useState([]);
  const [confirmPopupData, setConfirmPopupData] = React.useState({
    callFrom: '',
    popupText: '',
  });
  const [undoData, setUndoData] = React.useState({});
  const activepgmCode = props?.location?.state?.rebateProgram
    ? props?.location?.state?.rebateProgram
    : props?.location?.value?.state?.rebateProgram;
  const find_acc_rec_fld = useSelector((state) =>
    state?.sharedState?.QtrAccountsRecReducer?.getAccRecFieldvalues?.find(
      (obj) => {
        return obj[activepgmCode];
      }
    )
  );
  const acc_rec_fld = find_acc_rec_fld?.[activepgmCode];
  const getSingleAccRecNDCList = useSelector(
    (state) => state?.sharedState?.QtrAccountsRecReducer?.getSingleAccRecNDCList
  );
  const find_ar_smry_single_qtr = useSelector((state) =>
    state?.sharedState?.ArSummaryQtrReducer?.ar_smry_single_qtr?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const ar_smry_single_qtr = find_ar_smry_single_qtr?.[activepgmCode];
  const find_getQuarterValue = useSelector((state) =>
    state?.sharedState?.ArSummaryQtrReducer?.getQuarterValue?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const getQuarterValue = find_getQuarterValue?.[activepgmCode];
  const find_getBalnceDue = useSelector((state) =>
    state?.sharedState?.QtrAccountsRecReducer?.getBalnceDue?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const getBalnceDue = find_getBalnceDue?.[activepgmCode]
    ? find_getBalnceDue?.[activepgmCode]
    : false;
  const find_getOverridden = useSelector((state) =>
    state?.sharedState?.QtrAccountsRecReducer?.getOverridden?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const getOverridden = find_getOverridden?.[activepgmCode]
    ? find_getOverridden?.[activepgmCode]
    : false;
  const find_getPaidInFull = useSelector((state) =>
    state?.sharedState?.QtrAccountsRecReducer?.getPaidInFull?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const getPaidInFull = find_getPaidInFull?.[activepgmCode]
    ? find_getPaidInFull?.[activepgmCode]
    : false;
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  // get single NDC detail list and redirect NDC detail single page
  React.useEffect(() => {
    if (getSingleAccRecNDCList && getSingleAccRecNDCList.status === '001') {
      goToArSummaryAccRecNDCSingle(props.history, acc_rec_fld?.pgmCd, dispatch);
      dispatch(ndcDetailFirstLoadAction(false));
      dispatch(singleAccRecNDCData([]));
    }
  }, [getSingleAccRecNDCList]);
  // redirect Go to account receivable single NDC Details page
  const handleGoToAccRecNDCDetail = (row) => {
    if (row) {
      setLoad(true);
      const payload = {
        mfgId: row.mfgId,
        startQuarter: getQuarterValue,
        aiUseOfficialURA: acc_rec_fld?.uraInfo === 'Official' ? 1 : 0,
        invoiceNumber: parseInt(row.invoiceNum),
        rebateProgramCd: acc_rec_fld?.pgmCd,
      };
      dispatch(getAccRecNDCSingleDetail(payload));
      dispatch(ndcDetailSingle({ ...row, ...acc_rec_fld, getQuarterValue }));
      if (UserDefaultValues) {
        if (UserDefaultValues?.dispBalanceDueNdcInd != 0)
          dispatch(
            dispatchNDCBalanceDue({
              [payload.rebateProgramCd]: true,
            })
          );
        else
          dispatch(
            dispatchNDCBalanceDue({
              [payload.rebateProgramCd]: false,
            })
          );
        if (UserDefaultValues?.dispOverriddenNdcInd != 0)
          dispatch(
            dispatchNDCOveridden({
              [payload.rebateProgramCd]: true,
            })
          );
        else
          dispatch(
            dispatchNDCOveridden({
              [payload.rebateProgramCd]: false,
            })
          );
        if (UserDefaultValues?.dispPaidInFullNdcInd != 0)
          dispatch(
            dispatchNDCPaidInFull({
              [payload.rebateProgramCd]: true,
            })
          );
        else
          dispatch(
            dispatchNDCPaidInFull({
              [payload.rebateProgramCd]: false,
            })
          );
      } else {
        dispatch(
          dispatchNDCBalanceDue({
            [payload.rebateProgramCd]: true,
          })
        );
        dispatch(
          dispatchNDCOveridden({
            [payload.rebateProgramCd]: true,
          })
        );
        dispatch(
          dispatchNDCPaidInFull({
            [payload.rebateProgramCd]: false,
          })
        );
      }
    }
  };
  // update invoice balance handler
  const qtrInvoiceBalancedHandler = (
    data,
    bl = getBalnceDue,
    ov = getOverridden,
    pf = getPaidInFull
  ) => {
    setLoad(true);
    getInvoiceDetails(data.data.invoiceNum).then((invDtl) => {
      setLoad(false);
      if (invDtl) {
        if (data.data.invoiceStatusCd === 'DB') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceDeclaredBalancedMsg);
        } else if (!invDtl?.invoiceFreezeDt) {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceFrozen);
        } else {
          const payloadData = {
            invoiceStatusCd: data.data.invoiceStatusCd,
            invoiceNum: data.data.invoiceNum,
            rebateProgramCd: acc_rec_fld?.pgmCd,
            invoiceQtr: getQuarterValue,
          };
          updateInvoiceBalanced(payloadData).then((res) => {
            if (res && res.data.status === '001') {
              setIsDialogOpen(true);
              if (res.data.response.invoiceStatus === 'DB') {
                setDialogText(AR_CONST.invoiceBalanceCompleted);
                const updatedStatusData =
                  ar_smry_single_qtr.quarterListInfo?.quarterList.map(
                    (item) => {
                      if (item.invoiceNum === data.data.invoiceNum) {
                        item.invoiceStatusCd = 'DB';
                      }
                      return item;
                    }
                  );
                // setQtrAccRecTableData(updatedStatusData);
                applyFilterForInvoiceBlns(bl, ov, pf, updatedStatusData);
              } else {
                setDialogText(res.data.response.responseMessage);
              }
            } else {
              setIsDialogOpen(true);
              setDialogText(AR_CONST.invoiceBalanceFailed);
            }
          });
        }
      }
    });
  };
  // undo invoice balance handler
  const qtrUndoInvoiceBalancedHandler = (
    data,
    bl = getBalnceDue,
    ov = getOverridden,
    pf = getPaidInFull
  ) => {
    if (
      data.data.invoiceStatusCd != 'DB' &&
      data.data.invoiceStatusCd != 'DBK'
    ) {
      // show confirmation popup
      setConfimPopup(true);
      setConfirmPopupData({
        callFrom: 'balance',
        popupText: AR_CONST.undoDeclareBalanced,
      });
      setUndoData(data);
    } else {
      const payloadData = {
        invoiceStatusCd: data.data.invoiceStatusCd,
        invoiceNum: data.data.invoiceNum,
        rebateProgramCd: acc_rec_fld?.pgmCd,
        invoiceQtr: getQuarterValue,
      };
      undoInvoiceBalanced(payloadData).then((res) => {
        if (res && res.data.response) {
          // Update table grid store
          const updatedStatusData =
            ar_smry_single_qtr.quarterListInfo?.quarterList.map((item) => {
              if (item.invoiceNum === data.data.invoiceNum)
                item.invoiceStatusCd = res.data.response?.invoiceStatus;
              return item;
            });
          // setQtrAccRecTableData(updatedStatusData);
          applyFilterForInvoiceBlns(bl, ov, pf, updatedStatusData);
          if (gridApi) gridApi.api.refreshCells();
          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoDeclareBalancedCompleted);
        } else {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoDeclareBalancedFailed);
        }
      });
    }
  };
  // ag-grid frame work component
  const frameworkComponents = {
    ActionCellRender: (cellInfo) => {
      const find_getBalnceDue = useSelector((state) =>
        state?.sharedState?.QtrAccountsRecReducer?.getBalnceDue?.find((obj) => {
          return obj[activepgmCode];
        })
      );
      const getBalnceDue = find_getBalnceDue?.[activepgmCode];
      const find_getOverridden = useSelector((state) =>
        state?.sharedState?.QtrAccountsRecReducer?.getOverridden?.find(
          (obj) => {
            return obj[activepgmCode];
          }
        )
      );
      const getOverridden = find_getOverridden?.[activepgmCode];
      const find_getPaidInFull = useSelector((state) =>
        state?.sharedState?.QtrAccountsRecReducer?.getPaidInFull?.find(
          (obj) => {
            return obj[activepgmCode];
          }
        )
      );
      const getPaidInFull = find_getPaidInFull?.[activepgmCode];
      return (
        <ActionDropDownComp
          data={cellInfo}
          loadfn={setLoad}
          extraData={{
            ...acc_rec_fld,
            bl: getBalnceDue,
            ov: getOverridden,
            pf: getPaidInFull,
          }}
          displayBy="qtrAccRec"
          selectPgm={false}
          handleGoToAccRecNDCDetail={handleGoToAccRecNDCDetail}
          qtrInvoiceBalancedHandler={qtrInvoiceBalancedHandler}
          qtrUndoInvoiceBalancedHandler={qtrUndoInvoiceBalancedHandler}
        />
      );
    },
    RedTextRender: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <CustomGridCellRendererComponent {...cellInfo} />;
      }
      return <RedTextRenderComp data={cellInfo} />;
    },
    FullNameRender: (cellInfo) => {
      return <NameTooltipComp data={cellInfo} />;
    },
    invoiceDateRenderer: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <b>{cellInfo.value}</b>;
      }
      if (cellInfo.value !== null && cellInfo.value !== '') {
        return (
          <div className="tdCell dib icon-btn-group">
            <span className="td-date-range">
              {moment(cellInfo.value).format('MM/DD/YYYY')}
              {'   '} <SVGComponent iconName="Icon_date-range" />
            </span>
          </div>
        );
      }
      return null;
    },
  };

  // ongrid ready for table component
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  // set quarter accounts recivabile table data
  React.useEffect(() => {
    if (ar_smry_single_qtr && ar_smry_single_qtr.quarterListInfo?.quarterList) {
      // const data = [
      //   {
      //     currBal: ar_smry_single_qtr.quarterListInfo.totalCurrBal,
      //     offsetDue: ar_smry_single_qtr.quarterListInfo.totalOffsetDue,
      //     baseStateAmtDue:
      //       ar_smry_single_qtr.quarterListInfo.totalBaseStateAmtDue,
      //     interestDue: ar_smry_single_qtr.quarterListInfo.totalInterestDue,
      //     totalDue: ar_smry_single_qtr.quarterListInfo.finalTotalDue,
      //     amtPaid: ar_smry_single_qtr.quarterListInfo.totalAmtPaid,
      //     offsetPaidAmt: ar_smry_single_qtr.quarterListInfo.totalOffsetPaidAmt,
      //     baseStatePaidAmount:
      //       ar_smry_single_qtr.quarterListInfo.totalBaseStatePaidAmount,
      //     interestPaid: ar_smry_single_qtr.quarterListInfo.totalInterestPaid,
      //     currInvAmt: ar_smry_single_qtr.quarterListInfo.totalCurrInvAmt,
      //     currentRoa: ar_smry_single_qtr.quarterListInfo.totalCurrentRoa,
      //     baseStateRebateAmount:
      //       ar_smry_single_qtr.quarterListInfo.totalBaseStateRebateAmount,
      //     origInvoiceAmt:
      //       ar_smry_single_qtr.quarterListInfo.totalOrigInvoiceAmt,
      //     adjustmentAmount:
      //       ar_smry_single_qtr.quarterListInfo.totalAdjustmentAmount,
      //     disputeCount: ar_smry_single_qtr.quarterListInfo.totalDisputeCount,
      //     disputeAmt: ar_smry_single_qtr.quarterListInfo.totalDisputeAmt,
      //     reimbAmt: ar_smry_single_qtr.quarterListInfo.totalReimbAmt,
      //     famPlanAmt: ar_smry_single_qtr.quarterListInfo.totalFamPlanAmt,
      //     fedAmt: ar_smry_single_qtr.quarterListInfo.totalFedAmt,
      //     stateAmt: ar_smry_single_qtr.quarterListInfo.totalStateAmt,
      //     actions: 'hide',
      //     invoiceDate: 'Total:',
      //     isBottomRow: true,
      //   },
      // ];
      // setPinned(data);
      applyFilterForInvoiceBlns(
        getBalnceDue,
        getOverridden,
        getPaidInFull,
        null
      );
    }
  }, [ar_smry_single_qtr, getBalnceDue, getOverridden, getPaidInFull]);
  // filter checkbox on change event
  const handleOnChangeEvent = (value, name) => {
    if (value === 1 && name === 'balanceDue') {
      dispatch(
        dispatchQARBalanceDue({
          [activepgmCode]: true,
        })
      );
      applyFilterForInvoiceBlns(true, getOverridden, getPaidInFull, null);
    } else if (value === 0 && name === 'balanceDue') {
      dispatch(
        dispatchQARBalanceDue({
          [activepgmCode]: false,
        })
      );
      applyFilterForInvoiceBlns(false, getOverridden, getPaidInFull, null);
    } else if (value === 1 && name === 'overridden') {
      dispatch(
        dispatchQAROveridden({
          [activepgmCode]: true,
        })
      );
      applyFilterForInvoiceBlns(getBalnceDue, true, getPaidInFull, null);
    } else if (value === 0 && name === 'overridden') {
      dispatch(
        dispatchQAROveridden({
          [activepgmCode]: false,
        })
      );
      applyFilterForInvoiceBlns(getBalnceDue, false, getPaidInFull, null);
    } else if (value === 1 && name === 'paidinfull') {
      dispatch(
        dispatchQARPaidInFull({
          [activepgmCode]: true,
        })
      );
      applyFilterForInvoiceBlns(getBalnceDue, getOverridden, true, null);
    } else if (value === 0 && name === 'paidinfull') {
      dispatch(
        dispatchQARPaidInFull({
          [activepgmCode]: false,
        })
      );
      applyFilterForInvoiceBlns(getBalnceDue, getOverridden, false, null);
    }
  };

  const getBgHighlighterColor = (obj) => {
    let bgColor = '';
    if (
      obj.invoiceStatusCd === 'DB' ||
      obj.invoiceStatusCd === 'FG' ||
      obj.invoiceStatusCd === 'WO'
    ) {
      bgColor = 'green-legend';
    } else if (obj.convertedQtrInd === 1) {
      bgColor = 'yellow-legend';
    } else if (obj.actions === 'hide') {
      bgColor = 'd-none';
    }
    return bgColor;
  };

  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  const sum = (data, property) =>
    data?.reduce((acc, obj) => acc + obj[property], 0);
  const setPinnedRowData = (data) => {
    const pdata = [
      {
        currBal: sum(data, 'currBal'),
        offsetDue: sum(data, 'offsetDue'),
        baseStateAmtDue: sum(data, 'baseStateAmtDue'),
        interestDue: sum(data, 'interestDue'),
        totalDue: sum(data, 'totalDue'),
        amtPaid: sum(data, 'amtPaid'),
        offsetPaidAmt: sum(data, 'offsetPaidAmt'),
        baseStatePaidAmount: sum(data, 'baseStatePaidAmount'),
        interestPaid: sum(data, 'interestPaid'),
        currInvAmt: sum(data, 'currInvAmt'),
        currentRoa: sum(data, 'currentRoa'),
        baseStateRebateAmount: sum(data, 'baseStateRebateAmount'),
        origInvoiceAmt: sum(data, 'origInvoiceAmt'),
        adjustmentAmount: sum(data, 'adjustmentAmount'),
        disputeCount: sum(data, 'disputeCount'),
        disputeAmt: sum(data, 'disputeAmt'),
        reimbAmt: sum(data, 'reimbAmt'),
        famPlanAmt: sum(data, 'famPlanAmt'),
        fedAmt: sum(data, 'fedAmt'),
        stateAmt: sum(data, 'stateAmt'),
        actions: 'hide',
        invoiceDate: 'Total:',
        isBottomRow: true,
      },
    ];
    setPinned(pdata);
  };
  React.useEffect(() => {
    if (filterApply) setPinnedRowData(filteredRows);
  }, [filterApply, filteredRows]);
  // apply filters while check on checkbox
  const applyFilterForInvoiceBlns = (bl, ov, pf, recData) => {
    let data = [];
    const qtrAccData =
      recData ||
      (ar_smry_single_qtr.quarterListInfo?.quarterList
        ? ar_smry_single_qtr.quarterListInfo?.quarterList
        : []);
    if (bl === false && ov === false && pf === true) {
      data = qtrAccData.filter((obj) => obj.invoiceStatusCd === 'PIF');
    } else if (bl === false && ov === true && pf === true) {
      data = qtrAccData.filter(
        (obj) =>
          obj.invoiceStatusCd === 'PIF' ||
          obj.invoiceStatusCd === 'BL' ||
          obj.invoiceStatusCd === 'WO' ||
          obj.invoiceStatusCd === 'FG' ||
          obj.invoiceStatusCd === 'DB' ||
          obj.invoiceStatusCd === 'DBK'
      );
    } else if (bl === true && ov === false && pf === true) {
      data = qtrAccData.filter(
        (obj) =>
          obj.invoiceStatusCd != 'WO' &&
          obj.invoiceStatusCd != 'FG' &&
          obj.invoiceStatusCd != 'DB' &&
          obj.invoiceStatusCd != 'DBK'
      );
    } else if (bl === false && ov === false && pf === false) {
      data = [];
    } else if (bl === false && ov === true && pf === false) {
      data = qtrAccData.filter(
        (obj) =>
          obj.invoiceStatusCd === 'WO' ||
          obj.invoiceStatusCd === 'FG' ||
          obj.invoiceStatusCd === 'DB' ||
          obj.invoiceStatusCd === 'DBK'
      );
    } else if (bl === true && ov === false && pf === false) {
      data = qtrAccData.filter(
        (obj) =>
          obj.invoiceStatusCd != 'PIF' &&
          obj.invoiceStatusCd != 'BL' &&
          obj.invoiceStatusCd != 'WO' &&
          obj.invoiceStatusCd != 'FG' &&
          obj.invoiceStatusCd != 'DB' &&
          obj.invoiceStatusCd != 'DBK'
      );
    } else if (bl === true && ov === true && pf === false) {
      data = qtrAccData.filter(
        (obj) => obj.invoiceStatusCd != 'PIF' && obj.invoiceStatusCd != 'BL'
      );
    } else {
      data = qtrAccData;
    }

    data = data.map((obj) => {
      obj.bgHighlighterColor = getBgHighlighterColor(obj);
      return obj;
    });

    setQtrAccRecTableData(JSON.parse(JSON.stringify(data)));
    setPinnedRowData(data);
    if (gridApi) gridApi.refreshCells();
  };

  let firstInfo = `Rebate Program: ${acc_rec_fld?.pgmInfo}`;
  let secondInfo = `Quarter: ${getQuarterValue}`;

  return (
    <div className="tabs-container ARScreen" data-testid="QtrAccountsRec">
      <Spinner load={load} />
      <CustomSeparator
        parent1="Research"
        parent2={`Quarterly Accounts Receivable [${acc_rec_fld?.pgmCd}]`}
      />
      {!fullScreenView && (
        <div className="row">
          <div className="col-12 frr-mt-9">
            <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
              <legend arai-hidden="true" className="d-none" />
              <div className="row">
                <div className="col-12 col-sm-6 col-xl-4">
                  <div className="mui-custom-form">
                    <TextField
                      id="rebateProgram"
                      label={rebateProgramLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={acc_rec_fld?.pgmInfo}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-xl-4">
                  <div className="mui-custom-form">
                    <TextField
                      id="quarter"
                      label={quarterLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={getQuarterValue}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-12 col-sm-12 col-lg-6 mt-3">
            <fieldset className="custom-fieldset w-100  px-4 d-flex align-items-center ">
              <legend>Invoice Balance</legend>
              <FormControlLabel
                className="ml-0 "
                data-testid="checked_ia"
                control={<Checkbox color="primary" className="mr-2" />}
                label={balanceDueLabel}
                value={getBalnceDue}
                checked={getBalnceDue}
                onChange={(e) => {
                  handleOnChangeEvent(e.target.checked ? 1 : 0, 'balanceDue');
                }}
              />
              <FormControlLabel
                className="ml-0"
                data-testid="checked_ia2"
                control={<Checkbox color="primary" className="mr-2" />}
                label={overriddenLabel}
                value={getOverridden}
                checked={getOverridden}
                onChange={(e) =>
                  handleOnChangeEvent(e.target.checked ? 1 : 0, 'overridden')
                }
              />
              <FormControlLabel
                className="ml-0"
                data-testid="checked_ia3"
                control={<Checkbox color="primary" className="mr-2" />}
                label={paidInFullLabel}
                value={getPaidInFull}
                checked={getPaidInFull}
                onChange={(e) =>
                  handleOnChangeEvent(e.target.checked ? 1 : 0, 'paidinfull')
                }
              />
            </fieldset>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-display-dropdown-cell">
          <TableGridWithFeatures
            data-testid="acc-rec-NDC-activity-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={() => setFullScreenView(!fullScreenView)}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            columnDefs={QtrAccRecColumns}
            rowData={qtrAccRecTableData || []}
            isScrollOn
            pinnedBottomRowData={
              qtrAccRecTableData?.length ? pinned : undefined
            }
            info={{ firstInfo, secondInfo }}
            hideColumnsInPdf={['actions']}
            exportFile
            animateRows
            sideBar={false}
            fileName={AtrAccountsRecLabel}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            getFilterApply={getFilterApply}
            onFilterData={onFilterChanged}
            frameworkComponents={frameworkComponents}
          />
        </div>
      </div>
      <CommonModal
        open={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
        }}
        className="dialog-420"
        viewAction
        viewHeader
        onOk={() => setIsDialogOpen(false)}
        okTitle="Ok"
        childrenComponent={dialogText}
        modalTitle="Quarterly Accounts Receivable"
      />
      <CommonModal
        open={confimPopup}
        className="dialog-420"
        viewAction
        viewHeader
        onOk={() => {
          setConfimPopup(false);
          qtrInvoiceBalancedHandler(undoData);
        }}
        okTitle="Ok"
        onClose={() => setConfimPopup(false)}
        childrenComponent={confirmPopupData?.popupText}
        closeTitle="Cancel"
      />
    </div>
  );
};

export default QtrAccountsRec;
